import './Footer.scss'

import AuthContext from 'lib/context/AuthContext'
import { isLoggedIn } from 'lib/util/self'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

const wwwUri = process.env.WWW_URI
const year = new Date().getFullYear()

export default function Footer() {
  const { self } = useContext(AuthContext)
  const [t] = useTranslation()

  return (
    <footer className="footer">
      <span className="footer__company">&copy; {year} Articulate Global, LLC</span>
      <span className="footer__links">
        <a href={`${wwwUri}/terms`}>{t('footer.terms')}</a>
        <a href={`${wwwUri}/privacy`}>{t('footer.privacy')}</a>
        {isLoggedIn(self) ? (
          <a href={`${wwwUri}/support`}>{t('footer.support')}</a>
        ) : (
          <a href={`${wwwUri}/pricing#faq`}>{t('footer.faqs')}</a>
        )}
        <a href="#" onClick={() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
        }}>{t('footer.cookiePreferences')}</a>
      </span>
    </footer>
  )
}
